<template>
    <div>
        <div>
            <el-button icon="el-icon-search" @click="refresh">刷新</el-button>
        </div>

        <div>
            <LineChart v-if="flag" :line-series="monitorData"></LineChart>
        </div>

    </div>
</template>

<script>
    import LineChart from '../../components/charts/LineChart.vue'

    export default {
        name: "PerEc",
        data() {
            return {
                flag: false,
                monitorData:[],
                tempIdx: 0,
                tempData:[                    {
                    name: '总部项目',
                    type: 'line',
                    stack: '总量1',   // stack---数据堆叠,stack去掉或给不同的值
                    data: [120, 132, 101, 134, 90, 230, 210]
                },
                    {
                        name: '银行渠道部',
                        type: 'line',
                        stack: '总量2',
                        data: [220, 182, 191, 234, 290, 330, 310]
                    },
                    {
                        name: '代理渠道部',
                        type: 'line',
                        stack: '总量3',
                        data: [150, 232, 201, 154, 190, 330, 410]
                    },
                    {
                        name: '市场部',
                        type: 'line',
                        stack: '总量4',
                        data: [320, 332, 301, 334, 390, 1330, 320]
                    },
                    {
                        name: '其它',
                        type: 'line',
                        stack: '总量5',
                        data: [820, 932, 901, 1934, 1290, 1330, 1320]
                    }]
            }
        },
        components:{
            LineChart
        },
        methods: {
            fetchData() {
                if(this.tempIdx<5)
                {
                    this.monitorData.push(this.tempData[this.tempIdx++]);
                }

                    this.flag = true;
            },
            refresh() {
                this.fetchData();
            }
        },
        mounted(){
            this.fetchData();
        }
    }
</script>

<style scoped>

</style>